import {LocalStorageKey, getFromLocalStorage, setInLocalStorage} from "../localStorage";
import {useLocalStorageItem} from "./useBrowserStorage";

export const getLatLong = () => getFromLocalStorage(LocalStorageKey.LatLong);

export const setLatLong = (coordinates: {x: number; y: number}) =>
  setInLocalStorage(LocalStorageKey.LatLong, coordinates);

export const useLatLong = () => useLocalStorageItem(LocalStorageKey.LatLong);
